<template>
  <section>
    <div
      class="relative overflow-x-auto shadow-md sm:rounded-lg min-h-[25vh] p-2"
    >
      <div
        class="flex items-center justify-between flex-column flex-wrap md:flex-row space-y-4 md:space-y-0 pb-4 bg-white"
      >
        <SearchInput v-model="searchTerm" />
      </div>

      <div class="sticky left-0 text-sm" :key="solicitations">
        <div
          class="flex items-center p-2 rounded-md m-1 border border-gray-500 w-full"
          v-for="(item, index) in solicitations" :key="index"
        >
          <div class="h-2.5 w-2.5 rounded-full me-2 bg-green-500"></div>

          <p class="w-1/2 my-auto text-start">
            <strong>
              {{
                item?.customer?.name.length > 20
                ? item?.customer?.name.slice(0, 20).concat('...')
                : item?.customer?.name
              }}
            </strong> quer se tornar um lutador
          </p>

          <div class="w-full flex justify-end gap-x-3">
            <Recuse
              @click="acceptFighter(item?.customer?.id, false)"
              :icon="PhX"
              :label="'Recusar'"
            />
            <Create
              @click="acceptFighter(item?.customer?.id, true)"
              :icon="PhUserCirclePlus"
              :label="'Aceitar'"
            />
          </div>
        </div>
      </div>

      <DataTable :data="filteredData" @delete="deleteCustomer">
        <template #head>
          <th scope="col" class="px-6 py-3">Nome</th>
          <th scope="col" class="px-6 py-3">E-mail</th>
          <th scope="col" class="px-6 py-3">Eventos</th>
          <th scope="col" class="px-6 py-3">#</th>
        </template>
      </DataTable>
    </div>

    <!-- drawer -->
    <Transition mode="out-in">
      <BaseModal :isOpen="isModalOpen" @update:isOpen="closeModal">
        <!-- drawer employee -->
        <div
          id="drawer-right-example"
          class="fixed top-0 right-0 z-40 h-screen overflow-y-auto transition-transform bg-white w-80 overflow-x-hidden"
          :class="{
            'translate-x-0': isModalOpen,
            'translate-x-full': !isModalOpen,
          }"
          tabindex="-1"
          aria-labelledby="drawer-right-label"
        >
          <section>
            <main class="flex flex-col h-screen">
              <!-- header -->
              <div class="bg-gray-100 p-2 pt-0 pb-0">
                <!-- TItulo -->
                <h5
                  id="drawer-right-label"
                  class="inline-flex items-center mb-4 text-lg font-semibold text-gray-600 dark:text-gray-600 mt-3 mr-6"
                >
                  <PhUserCircle class="w-8 h-8 me-2.5 text-gray-700" />
                  {{ modalContent.name }}
                </h5>

                <!-- close button -->
                <button
                  type="button"
                  aria-controls="drawer-right-example"
                  class="text-gray-400 bg-transparent hover:text-gray-700 text-sm w-8 h-8 absolute -end-2 mt-3 mr-2"
                  @click="closeModal"
                >
                  <component :is="PhX" class="w-7 h-6"></component>
                </button>
              </div>

              <!-- content -->
              <section class="p-2">
                <div class="pt-0 pb-0 mb-4">
                  <!-- eventos -->
                  <div class="w-full">
                    <section
                      class="text-lg w-full p-5 pt-0 pb-0 px-1 font-semibold text-left text-gray-900 bg-white uppercase"
                    >
                      meus eventos
                      <p
                        class="-mt-0.5 text-sm font-normal text-gray-500 lowercase"
                      >
                        Eventos que tenho acesso
                      </p>
                    </section>
                  </div>

                  <!-- lista -->
                  <div class="text-sm w-full font-semibold pb-1">
                    <div class="w-full">
                      <div class="overflow-x-hidden py-2 rounded-md">
                        <table class="w-full uppercase">
                          <thead>
                            <tr class="lowercase">
                              <TableHeadField>
                                <span class="text-gray-400"> evento </span>
                              </TableHeadField>

                              <TableHeadField>
                                <span class="text-gray-400"> card </span>
                              </TableHeadField>
                            </tr>
                          </thead>

                          <tbody>
                            <tr
                              v-for="(row, index) in modalContent.my_events"
                              :key="index"
                              class="hover:shadow-lg hover:-translate-y-1 hover:-translate-x-1 transition-all z-9"
                              :class="
                                index % 2 === 0 ? 'bg-gray-100' : 'bg-white'
                              "
                            >
                              <!-- nome -->
                              <td
                                class="text-left whitespace-nowrap pr-3 text-sm text-gray-900 sm:pl-0 min-w-[10px] py-2"
                              >
                                <div>
                                  <span class="pl-2">
                                    {{
                                      row["event"]["title"]?.length > 18
                                        ? row["event"]["title"]
                                            .slice(0, 18)
                                            .concat("...")
                                        : row["event"]["title"]
                                    }}
                                  </span>
                                </div>
                              </td>

                              <!-- card -->
                              <td
                                class="text-left whitespace-nowrap pr-3 text-sm text-gray-900 sm:pl-0 min-w-[10px] py-2"
                              >
                                <div>
                                  <span
                                    class="pl-2"
                                    :class="[
                                      row['event']['tag'] == null
                                        ? 'italic text-gray-500'
                                        : '',
                                    ]"
                                  >
                                    {{
                                      row["event"]["tag"]?.length > 15
                                        ? row["event"]["tag"]
                                            .slice(0, 15)
                                            .concat("...")
                                        : row["event"]["tag"] ?? "sem card"
                                    }}
                                  </span>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>

                  <!-- patrocinios -->
                  <div class="w-full border-t pt-1 border-gray-400">
                    <section
                      class="text-lg w-full p-5 pt-0 pb-1 px-1 font-semibold text-left text-gray-900 bg-white uppercase"
                    >
                      Patrocinios
                      <p
                        class="-mt-0.5 text-sm font-normal text-gray-500 lowercase"
                      >
                        Lutadores que patrocino
                      </p>
                    </section>
                  </div>

                  <!-- lista -->
                  <div class="text-sm w-full font-semibold pb-1">
                    <div class="w-full">
                      <div class="overflow-x-hidden py-2 rounded-md">
                        <table class="w-full uppercase">
                          <thead>
                            <tr class="lowercase">
                              <TableHeadField>
                                <span class="text-gray-400"> lutador </span>
                              </TableHeadField>
                            </tr>
                          </thead>

                          <tbody>
                            <tr
                              v-for="(row, index) in modalContent.my_events"
                              :key="index"
                              class="hover:shadow-lg hover:-translate-y-1 hover:-translate-x-1 transition-all z-9"
                              :class="
                                index % 2 === 0 ? 'bg-gray-100' : 'bg-white'
                              "
                            >
                              <!-- nome -->
                              <td
                                class="text-left whitespace-nowrap pr-3 text-sm text-gray-900 sm:pl-0 min-w-[10px] py-2"
                                v-if="row['coupon']"
                              >
                                <div>
                                  <span class="pl-2">
                                    {{
                                      row["coupon"]["customer"]["name"]
                                        ?.length > 30
                                        ? row["coupon"]["customer"]["name"]
                                            .slice(0, 30)
                                            .concat("...")
                                        : row["coupon"]["customer"]["name"] ??
                                          ""
                                    }}
                                  </span>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </main>
          </section>
        </div>
      </BaseModal>
    </Transition>
  </section>
</template>

<script setup>
import SearchInput from '@/components/Tables/SearchInput.vue'
import DataTable from '@/components/Tables/DataTable.vue'
import AsosService from '../../service/asos.service'
import { showToast as toast } from '@/helpers/UseToasts'
import { computed, onMounted, ref } from 'vue'
import { dataAso } from './../../store'
import { initFlowbite } from 'flowbite'
import { storeApp } from '@/store'

import { PhInfo, PhUserCircle, PhUserCirclePlus, PhX } from '@phosphor-icons/vue'
import BaseModal from '@/components/Modals/BaseModal.vue'
import TableHeadField from '@/components/Tables/TableHeadField.vue'
import Create from '@/components/Buttons/Create.vue'
import Recuse from '@/components/Buttons/Recuse.vue'

const store = dataAso
const searchTerm = ref('')
const solicitations = ref([])
const isModalOpen = computed(() => store.getters.getDrawerModal)
const modalContent = computed(() => store.getters.getDrawerModalContent)

const dataTable = computed(() => store.getters?.getDocs)

// filtros
const filteredData = computed(() => {
  const searchTermLower = searchTerm.value?.toLowerCase()

  return dataTable.value.filter((row) => {
    const matchesSearch =
      !searchTerm.value ||
      ['name', 'email'].some(
        (key) =>
          row[key] &&
          row[key].toString().toLowerCase().includes(searchTermLower)
      )

    return matchesSearch
  })
})

function closeModal () {
  store.dispatch('setModalDesactive')
}

async function deleteCustomer (id) {
  storeApp.state.loading = true
  const confirm = window.confirm('Deseja realmente remover esse assinante?')
  if (confirm) {
    // apaga o doc do servidor
    await AsosService.removeCustomer(id)
      .then((res) => {
        storeApp.state.loading = false

        if (res?.data?.success) {
          dataAso.dispatch('setAllDocs', res?.data?.customers)

          return toast('Sucesso', res?.data?.message, 'success')
        }
      })
      .catch((err) => {
        storeApp.state.loading = false

        if (err?.response?.data?.error && err.response.data.status === 404) {
          return toast('Aviso', err.response.data.message, 'error')
        }

        return toast('Aviso', 'Algo deu errado ao remover assinante', 'error')
      })
  }
  storeApp.state.loading = false
}

async function getSolicitation () {
  AsosService.getSolicitations()
    .then(res => {
      solicitations.value = []
      solicitations.value = res.data
    })
}

async function acceptFighter (id, payload) {
  AsosService.acceptSolicitation(id, payload)
    .then(res => {
      if (res.data.success) {
        toast(
          'Sucesso',
          'Novo lutador adicionado',
          'success'
        )

        Promise.all([
          getDocs(),
          getSolicitation()
        ])
      }
    })
}

async function getDocs () {
  await AsosService.getCustomers()
    .then(res => {
      dataAso.dispatch('setAllDocs', res.data)
    }).catch(err => {
      console.log(err)
    })
}

onMounted(() => {
  initFlowbite()

  Promise.all([
    getSolicitation()
  ])
})
</script>
